export default __webpack_public_path__ + "static/media/eduplusnow-removebg-preview.82b48e73.png";